import styled from 'styled-components';

const RowDivider = styled.hr`
    margin-top: 0;
    margin-bottom: 24px;
    border: none;
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.colors.grey400};
`;

export default RowDivider;
